var _rect, _path, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInkPen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#CFE7FC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29 21.9998L22.5018 23.2995C22.1388 23.3721 21.9573 23.4084 21.8095 23.4967C21.6789 23.5747 21.5677 23.6815 21.4846 23.809C21.3906 23.9532 21.3471 24.1331 21.2603 24.493L18 37.9998M18 37.9998L31.5069 34.7396C31.8667 34.6527 32.0466 34.6093 32.1908 34.5153C32.3183 34.4321 32.4252 34.321 32.5032 34.1903C32.5915 34.0425 32.6278 33.861 32.7004 33.498L34 26.9998M18 37.9998L25.586 30.4138M36.8686 23.8685L32.1314 19.1312C31.7354 18.7352 31.5373 18.5372 31.309 18.463C31.1082 18.3977 30.8918 18.3977 30.691 18.463C30.4627 18.5372 30.2646 18.7352 29.8686 19.1312L29.1314 19.8685C28.7354 20.2645 28.5373 20.4625 28.4632 20.6908C28.3979 20.8917 28.3979 21.108 28.4632 21.3089C28.5373 21.5372 28.7354 21.7352 29.1314 22.1312L33.8686 26.8685C34.2646 27.2645 34.4627 27.4625 34.691 27.5367C34.8918 27.6019 35.1082 27.6019 35.309 27.5367C35.5373 27.4625 35.7354 27.2645 36.1314 26.8685L36.8686 26.1312C37.2646 25.7352 37.4627 25.5372 37.5368 25.3089C37.6021 25.108 37.6021 24.8917 37.5368 24.6908C37.4627 24.4625 37.2646 24.2645 36.8686 23.8685ZM27 26.9998C28.1046 26.9998 29 27.8953 29 28.9998C29 30.1044 28.1046 30.9998 27 30.9998C25.8954 30.9998 25 30.1044 25 28.9998C25 27.8953 25.8954 26.9998 27 26.9998Z",
    stroke: "#0D67B5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    stroke: "#E2F1FD",
    strokeWidth: 8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInkPen);
export default __webpack_public_path__ + "static/media/ink-pen.262d533dae6c119d277146600e5d9143.svg";
export { ForwardRef as ReactComponent };